import { apiClient } from './client';
import { API_CONFIG } from './config';

export type UserEntity = {
  userId: string;
  name: string;
  email: string;
  username: string;
  role: string;
  status: string;
  title: string | null;
  description: string | null;
  service: string | null;
  occupation: string | null;
  phoneNo: string | null;
  country: string | null;
  address: string | null;
  profilePicture: string | null;
  profilePictureFile?: { fileId: string; s3Url: string } | null;
  isProfileDisplay: boolean;
  performService: boolean;
  createdAt: string;
  updatedAt: string;
  [key: string]: unknown;
};

export type UsersListResponse = {
  data: UserEntity[];
  total: number;
  skip: number;
  limit: number;
};

export type CreateUserRequest = {
  name: string;
  email: string;
  username: string;
  password: string;
  role?: string;
  status?: string;
  [key: string]: unknown;
};

export type UpdateUserRequest = Partial<Omit<CreateUserRequest, 'password'>>;

class UsersApi {
  private ep = API_CONFIG.endpoints.users;

  list(params?: { skip?: number; limit?: number; search?: string; role?: string; status?: string }) {
    return apiClient.get<UsersListResponse>(this.ep.list, { params });
  }

  getById(id: string) {
    return apiClient.get<UserEntity>(this.ep.byId(id));
  }

  create(data: CreateUserRequest) {
    return apiClient.post<UserEntity>(this.ep.create, data);
  }

  update(id: string, data: UpdateUserRequest) {
    return apiClient.patch<UserEntity>(this.ep.update(id), data);
  }

  delete(id: string) {
    return apiClient.delete(this.ep.delete(id));
  }
}

export const usersApi = new UsersApi();
